
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../../components/Navbar.js";
import Select from "react-select";
import LOGO from "../../../assets/images/logo.png";
import SignatureCanvas from 'react-signature-canvas';
import Pagination from '@mui/material/Pagination';
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,
} from "../../../components/CustomComponent.js";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";

export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal_create_brand: false,
            modal_create_model: false,
            modal_delete_brand: false,
            modal_delete_model: false,
            modal_update_brand: false,
            modal_update_model: false,


            loading: false,
            data_brand_0: [],
            data_brand: null,
            data_model: null,

            page_brand: 0,
            page_model: 0,

            filter_brand_name: "",
            brand_id: "",
            brand_name: "",
            brand_detail: "",


            filter_model_name: "",
            model_id: "",
            model_name: "",
            model_detail: "",

            page_brand: 1,
            data_search_brand: "",
            page_model: 1,
            data_search_model: "",

        }
    }
    async componentDidMount() {
        await this.getBrandAll();
        await this.getModelAll();
        await this.getBrand0();
    }
    getBrand0 = async () => {
        let body = {
            page: 0,
            data_search: "",
            brand_id: ""
        }
        let result = await GET(tokens, "v1/TH/car-manage/brand/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log("getBrand0:", result);
            this.setState({ data_brand_0: result.data.map(e => { return { value: e.brand_id, label: e.brand_name } }) });
        }
    }
    getBrandAll = async () => {
        let body = {
            page: this.state.page_brand,
            data_search: this.state.data_search_brand,
            brand_id: this.state.brand_id
        }
        let result = await GET(tokens, "v1/TH/car-manage/brand/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({
                data_brand: result

            });
        }
    }
    getModelAll = async () => {
        let body = {
            page: this.state.page_model,
            data_search: this.state.data_search_model,
            model_id: this.state.model_id
        }
        let result = await GET(tokens, "v1/TH/car-manage/model/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({
                data_model: result
            });
        }
    }
    CreateBrand = async () => {
        if (validate(this.state, ["brand_name"])) { return };
        this.setState({ loading: true });
        let body = {
            brand_name: this.state.brand_name,
            brand_detail: this.state.brand_detail,
        }
        let result = await POST(tokens, "v1/TH/car-manage/brand/create/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            success_url("/master/list-car");
        }
        this.setState({ loading: false });
    }
    UpdateBrand = async () => {
        if (validate(this.state, ["brand_name"])) { return };
        this.setState({ loading: true });
        let body = {
            brand_id: this.state.brand_id,
            brand_name: this.state.brand_name,
            brand_detail: this.state.brand_detail,
        }
        let result = await PUT(tokens, "v1/TH/car-manage/brand/update", body);
        if (result && result.status) {
            success_url("/master/list-car");
        }
        this.setState({ loading: false });
    }
    DeleteBrand = async () => {
        this.setState({ loading: true });
        let result = await DELETE(tokens, "v1/TH/car-manage/brand/delete/" + this.state.brand_id, null);
        if (result && result.status) {
            success_url("/master/list-car");
        }
        this.setState({ loading: false });
    }
    CreateModel = async () => {
        if (validate(this.state, ["brand_id", "model_name"])) { return };
        this.setState({ loading: true });
        let body = {
            brand_id: this.state.brand_id ? this.state.brand_id.value : "",
            model_name: this.state.model_name,
            model_detail: this.state.model_detail,
        }
        let result = await POST(tokens, "v1/TH/car-manage/model/create/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            success_url("/master/list-car");
        }
        this.setState({ loading: false });
    }
    UpdateModel = async () => {
        if (validate(this.state, ["brand_id", "model_name"])) { return };
        this.setState({ loading: true });
        let body = {
            model_id: this.state.model_id,
            brand_id: this.state.brand_id ? this.state.brand_id.value : "",
            model_name: this.state.model_name,
            model_detail: this.state.model_detail,
        }
        let result = await PUT(tokens, "v1/TH/car-manage/model/update", body);
        if (result && result.status) {
            success_url("/master/list-car");
        }
        this.setState({ loading: false });
    }
    DeleteModel = async () => {
        this.setState({ loading: true });
        let result = await DELETE(tokens, "v1/TH/car-manage/model/delete/" + this.state.model_id, null);
        if (result && result.status) {
            success_url("/master/list-car");
        }
        this.setState({ loading: false });
    }
    clear_form = () => {
        this.setState({
            modal_create_brand: false,
            modal_create_model: false,
            modal_delete_brand: false,
            modal_delete_model: false,
            modal_update_brand: false,
            modal_update_model: false,

            loading: false,

            brand_id: "",
            brand_name: "",
            brand_detail: "",

            model_id: "",
            model_name: "",
            model_detail: ""
        })
    }
    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="จัดการระบบ" page3="จัดการรถ" />
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex mx-0 align-items-center justify-content-between test mb-2 flex-wrap">
                            <h3 className="mb-2"><b>จัดการรถ</b></h3>
                            <div className="d-flex">
                                <button className="btn btn-outline-orange mx-1" onClick={() => { window.location.href = "/master" }}>
                                    <span className="icon me-2">{"\uf060"}</span>ย้อนกลับ
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <div className="w-100 card border-0 p-0">
                                    <div className="d-flex justify-content-between align-items-center px-2 pt-3">
                                        <h3 className="mb-2"><b>จัดการยี่ห้อรถ</b></h3>
                                        <button className="btn btn-orange mx-1" onClick={() => {
                                            this.clear_form();
                                            setTimeout(() => {
                                                this.setState({ modal_create_brand: true })
                                            }, 10);
                                        }}>
                                            เพ่ิมยี่ห้อรถ
                                        </button>
                                    </div>
                                    <div className="d-flex mx-0 px-2 flex-wrap">
                                        <input
                                            className="form-control wpx-250 bg-contain border-0 me-1 mb-2"
                                            type="text"
                                            placeholder=""
                                            onChange={(e) => { this.setState({ data_search_brand: e.target.value }) }}
                                            onKeyUp={(e) => {
                                                if (e.key === "Enter") {
                                                    this.setState({ page_brand: 1, brand_id: "" });
                                                    setTimeout(() => {
                                                        this.getBrandAll();
                                                    }, 10);
                                                }
                                            }}
                                            value={this.state.data_search_brand}
                                        />
                                        <div className="d-flex">
                                            <button className="btn btn-orange mx-1 mb-2" onClick={() => {
                                                this.setState({ page_brand: 1, brand_id: "" });
                                                setTimeout(() => {
                                                    this.getBrandAll();
                                                }, 10);
                                            }}>
                                                ค้นหา
                                            </button>
                                            <button className="btn btn-outline-orange mx-1 mb-2" onClick={() => {
                                                this.setState({ page_brand: 1, brand_id: "", data_search_brand: "" });
                                                setTimeout(() => {
                                                    this.getBrandAll();
                                                }, 10);
                                            }}>
                                                รีเซ็ต
                                            </button>
                                        </div>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-borderless table-striped">
                                            <thead className="bg-primary">
                                                <tr>
                                                    <th className="text-center text-white">ลำดับ</th>
                                                    <th className="text-left text-white">ยี่ห้อ</th>
                                                    <th className="text-left text-white">รายละเอียด</th>
                                                    <th className="text-center text-white">จัดการ</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.data_brand && this.state.data_brand.data.map((item, index) => (
                                                    <tr key={index}>
                                                        <td className="text-center">{((this.state.page_brand - 1) * 10) + index + 1}</td>
                                                        <td className="text-left">{item.brand_name ? item.brand_name : "-"}</td>
                                                        <td className="text-left">{item.brand_detail ? item.brand_detail : "-"}</td>
                                                        <td className="text-center">
                                                            <div className="w-100 d-flex justify-content-center">
                                                                <div className="pointer wpx-30 hpx-30 rounded bg-primary-light mx-1 d-flex justify-content-center align-items-center"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            modal_update_brand: true,
                                                                            brand_id: item.brand_id,
                                                                            brand_name: item.brand_name,
                                                                            brand_detail: item.brand_detail,
                                                                        })
                                                                    }}>
                                                                    <label className="pointer icon text-primary p-2">{"\uf044"}</label>
                                                                </div>
                                                                <div className="pointer wpx-30 hpx-30 rounded bg-danger-light mx-1 d-flex justify-content-center align-items-center"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            modal_delete_brand: true,
                                                                            brand_id: item.brand_id,
                                                                            brand_name: item.brand_name,
                                                                            brand_detail: item.brand_detail,
                                                                        })
                                                                    }}>
                                                                    <label className="pointer icon text-danger p-2">{"\uf2ed"}</label>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        {/* pagination */}
                                        {this.state.data_brand && (
                                            <div className="d-flex flex-wrap justify-content-between w-100 px-3 mt-3">
                                                <label>
                                                    แสดง {this.state.data_brand.end_index} รายการ จาก {this.state.data_brand.count} รายการ
                                                </label>
                                                <Pagination
                                                    count={this.state.data_brand.page_number}
                                                    page={this.state.data_brand.page}
                                                    color="primary"
                                                    showFirstButton
                                                    shape="rounded"
                                                    showLastButton
                                                    onChange={(event, value) => {
                                                        this.setState({ page_brand: value })
                                                        setTimeout(() => { this.getBrandAll() }, 5)
                                                    }} />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="w-100 card border-0 p-0">
                                    <div className="d-flex justify-content-between align-items-center px-2 pt-3">
                                        <h3 className="mb-2"><b>จัดการรุ่นรถ</b></h3>
                                        <button className="btn btn-orange mx-1" onClick={() => {
                                            this.clear_form();
                                            setTimeout(() => {
                                                this.setState({ modal_create_model: true })
                                            }, 10);
                                        }}>
                                            เพ่ิมรุ่นรถ
                                        </button>
                                    </div>
                                    <div className="d-flex mx-0 px-2 flex-wrap">
                                        <input
                                            className="form-control wpx-250 bg-contain border-0 me-1 mb-2"
                                            type="text"
                                            placeholder=""
                                            onChange={(e) => { this.setState({ data_search_model: e.target.value }) }}
                                            onKeyUp={(e) => {
                                                if (e.key === "Enter") {
                                                    this.setState({ page_model: 1, model_id: "" });
                                                    setTimeout(() => {
                                                        this.getModelAll();
                                                    }, 10);
                                                }
                                            }}
                                            value={this.state.data_search_model}
                                        />
                                        <div className="d-flex">
                                            <button className="btn btn-orange mx-1 mb-2" onClick={() => {
                                                this.setState({ page_model: 1, model_id: "" });
                                                setTimeout(() => {
                                                    this.getModelAll();
                                                }, 10);
                                            }}>
                                                ค้นหา
                                            </button>
                                            <button className="btn btn-outline-orange mx-1 mb-2" onClick={() => {
                                                this.setState({ page_model: 1, model_id: "", data_search_model: "" });
                                                setTimeout(() => {
                                                    this.getModelAll();
                                                }, 10);
                                            }}>
                                                รีเซ็ต
                                            </button></div>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-borderless table-striped">
                                            <thead className="bg-primary">
                                                <tr>
                                                    <th className="text-center text-white">ลำดับ</th>
                                                    <th className="text-left text-white">ยี่ห้อ</th>
                                                    <th className="text-left text-white">รุ่น</th>
                                                    <th className="text-left text-white">รายละเอียด</th>
                                                    <th className="text-center text-white">จัดการ</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.data_model && this.state.data_model.data.map((item, index) => (
                                                    <tr key={index}>
                                                        <td className="text-center">{((this.state.page_model - 1) * 10) + index + 1}</td>
                                                        <td className="text-left">{item.brand_name ? item.brand_name : "-"}</td>
                                                        <td className="text-left">{item.model_name ? item.model_name : "-"}</td>
                                                        <td className="text-left">{item.model_detail ? item.model_detail : "-"}</td>
                                                        <td className="text-center">
                                                            <div className="w-100 d-flex justify-content-center">
                                                                <div className="pointer wpx-30 hpx-30 rounded bg-primary-light mx-1 d-flex justify-content-center align-items-center"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            modal_update_model: true,

                                                                            brand_id: this.state.data_brand_0.filter(e => e.value === item.brand_id)[0],
                                                                            model_id: item.model_id,
                                                                            model_name: item.model_name,
                                                                            model_detail: item.model_detail,
                                                                        })
                                                                    }}>
                                                                    <label className="pointer icon text-primary p-2">{"\uf044"}</label>
                                                                </div>
                                                                <div className="pointer wpx-30 hpx-30 rounded bg-danger-light mx-1 d-flex justify-content-center align-items-center"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            modal_delete_model: true,

                                                                            brand_id: this.state.data_brand_0.filter(e => e.value === item.brand_id)[0],
                                                                            model_id: item.model_id,
                                                                            model_name: item.model_name,
                                                                            model_detail: item.model_detail,
                                                                        })
                                                                    }}>
                                                                    <label className="pointer icon text-danger p-2">{"\uf2ed"}</label>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        {/* pagination */}
                                        {this.state.data_model && (
                                            <div className="d-flex flex-wrap justify-content-between w-100 px-3 mt-3">
                                                <label>
                                                    แสดง {this.state.data_model.end_index} รายการ จาก {this.state.data_model.count} รายการ
                                                </label>
                                                <Pagination
                                                    count={this.state.data_model.page_number}
                                                    page={this.state.data_model.page}
                                                    color="primary"
                                                    showFirstButton
                                                    shape="rounded"
                                                    showLastButton
                                                    onChange={(event, value) => {
                                                        this.setState({ page_model: value })
                                                        setTimeout(() => { this.getModelAll() }, 5)
                                                    }} />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* create update */}
                <Modal show={this.state.modal_create_brand || this.state.modal_update_brand}
                    onHide={() => { this.setState({ modal_create_brand: false, modal_update_brand: false }) }}>
                    <Modal.Header><Modal.Title><b>{this.state.modal_create_brand ? "เพิ่มยี่ห้อ" : "แก้ไขยี่ห้อ"}</b></Modal.Title></Modal.Header>
                    <Modal.Body>
                        {/* ยี่ห้อ */}
                        <div className="w-100 mb-2">
                            <label className="mb-2">ยี่ห้อ:</label>
                            <input
                                className="form-control"
                                type="text"
                                placeholder=""
                                onChange={(e) => { this.setState({ brand_name: e.target.value }) }}
                                value={this.state.brand_name}
                            />
                        </div>
                        {/* รายละเอียด */}
                        <div className="w-100 mb-2">
                            <label className="mb-2">รายละเอียด:</label>
                            <textarea
                                className="form-control"
                                placeholder=""
                                onChange={(e) => {
                                    this.setState({ brand_detail: e.target.value })
                                }}
                                value={this.state.brand_detail}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-outline-orange w-100" onClick={() => { this.setState({ modal_create_brand: false, modal_update_brand: false }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-orange w-100"
                                    onClick={() => {
                                        if (this.state.modal_create_brand) {
                                            this.CreateBrand();
                                        } else {
                                            this.UpdateBrand();
                                        }
                                    }}>
                                    {this.state.modal_create_brand ? "เพิ่ม" : "บันทึก"}
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
                {/* create update */}
                <Modal show={this.state.modal_create_model || this.state.modal_update_model}
                    onHide={() => { this.setState({ modal_create_model: false, modal_update_model: false }) }}>
                    <Modal.Header><Modal.Title><b>{this.state.modal_create_model ? "เพิ่มรุ่นรถ" : "แก้ไขรุ่นรถ"}</b></Modal.Title></Modal.Header>
                    <Modal.Body>
                        {/* รุ่น */}
                        <div className="w-100 mb-2">
                            <label className="mb-2">ยี่ห้อ:</label>
                            <Select
                                className="form-control select-search"
                                styles={select_style}
                                options={this.state.data_brand_0}
                                onChange={(e) => {
                                    this.setState({ brand_id: e });
                                }}
                                value={this.state.brand_id}
                                isClearable
                            ></Select>
                        </div>
                        {/* รุ่น */}
                        <div className="w-100 mb-2">
                            <label className="mb-2">รุ่น:</label>
                            <input
                                className="form-control"
                                type="text"
                                placeholder=""
                                onChange={(e) => { this.setState({ model_name: e.target.value }) }}
                                value={this.state.model_name}
                            />
                        </div>
                        {/* รายละเอียด */}
                        <div className="w-100 mb-2">
                            <label className="mb-2">รายละเอียด:</label>
                            <textarea
                                className="form-control"
                                placeholder=""
                                onChange={(e) => {
                                    this.setState({ model_detail: e.target.value })
                                }}
                                value={this.state.model_detail}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-outline-orange w-100" onClick={() => { this.setState({ modal_create_model: false, modal_update_model: false }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-orange w-100"
                                    onClick={() => {
                                        if (this.state.modal_create_model) {
                                            this.CreateModel();
                                        } else {
                                            this.UpdateModel();
                                        }
                                    }}>
                                    {this.state.modal_create_model ? "เพิ่ม" : "บันทึก"}
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
                {/* ลบข้อมูล */}
                <Modal show={this.state.modal_delete_brand} onHide={() => { this.setState({ modal_delete_brand: false }) }}>
                    <Modal.Header> <Modal.Title> <b>ต้องการลบยี่ห้อรถ</b> </Modal.Title> </Modal.Header>
                    <Modal.Body>
                        <label>
                            ท่านต้องการลบยี่ห้อรถ “{this.state.brand_name}”
                        </label>
                    </Modal.Body>
                    <Modal.Footer>
                        <label className="mb-2 w-100">
                            หมายเหตุ ไม่สามารถกู้คืนได้
                        </label>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-danger w-100" onClick={() => { this.DeleteBrand() }}>
                                    ลบ
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-outline-danger w-100" onClick={() => { this.setState({ modal_delete_brand: false }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
                {/* ลบข้อมูล */}
                <Modal show={this.state.modal_delete_model} onHide={() => { this.setState({ modal_delete_model: false }) }}>
                    <Modal.Header> <Modal.Title> <b>ต้องการลบรุ่นรรถ</b> </Modal.Title> </Modal.Header>
                    <Modal.Body>
                        <label>
                            ท่านต้องการลบรุ่นรรถ “{this.state.model_name}”
                        </label>
                    </Modal.Body>
                    <Modal.Footer>
                        <label className="mb-2 w-100">
                            หมายเหตุ ไม่สามารถกู้คืนได้
                        </label>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-danger w-100" onClick={() => { this.DeleteModel() }}>
                                    ลบ
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-outline-danger w-100" onClick={() => { this.setState({ modal_delete_model: false }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div >
        )
    }
}
